import { Card, CardHeader, CardTitle } from "@/components/ui/card";
import { useAppWorkspace } from "@/contexts/AppWorkspaceContext";

interface FeatureCard {
  title: string;
  image: string;
  onClick?: () => void;
  clickable: boolean;
}

const features: FeatureCard[] = [
  {
    title: "Craft",
    image: "/demo_1.png",
    clickable: false,
  },
  {
    title: "Design",
    image: "/demo_2.png",
    clickable: false,
  },
  {
    title: "Simulate & Test",
    image: "/demo_3.png",
    clickable: true,
    onClick: () => {
      window.location.hash = "#chat-v2";
    },
  },
  {
    title: "Analyze",
    image: "/demo_4.png",
    clickable: false,
  },
];

export function HomePage() {
  const { activeWorkspace } = useAppWorkspace();

  return (
    <div className="flex flex-1 w-full items-center justify-center p-12 overflow-auto">
      <div className="w-full max-w-6xl">
        <h1 className="text-3xl font-semibold text-center mb-16 tracking-tight">
          What's next for {activeWorkspace?.name || "your workspace"}?
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-10">
          {features.map((feature) => (
            <Card
              key={feature.title}
              className={`overflow-hidden transition-all duration-300 ${
                feature.clickable
                  ? "cursor-pointer hover:scale-[1.01] hover:shadow-lg"
                  : "opacity-70"
              }`}
              onClick={feature.onClick}
            >
              <div className="relative w-full h-48 overflow-hidden bg-muted">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <CardHeader className="py-5">
                <CardTitle className="text-xl font-medium">
                  {feature.title}
                  {!feature.clickable && (
                    <span className="text-muted-foreground font-normal">
                      {" "}
                      - Coming Soon
                    </span>
                  )}
                </CardTitle>
              </CardHeader>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}
